import "../assets/css/style.css";
import LeftGnb from "../components/leftGnb";
import {useEffect, useState} from "react";
import AppHeader from "../components/app_header";
import dom2pdf from "dom2pdf";
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";

const Report = () => {
    useEffect(() => {
        function resizeElement() {
            document.querySelectorAll(".report_item_right .contentEditable_wrapper").forEach((item, idx) => {
                item.addEventListener("keyup", function () {
                    if (this.parentNode.parentNode.querySelectorAll(".report_item_left")[0].scrollHeight !== this.scrollHeight) {
                        this.parentNode.parentNode.querySelectorAll(".report_item_left")[0].style.height = this.scrollHeight + "px";
                    }
                });
            });
        }
        resizeElement();
        document.querySelectorAll(".export_to_pdf")[0].addEventListener("click", function () {
            const node = document.querySelectorAll(".report_wrapper")[0];
            function filter(node) {
                return node.tagName !== "BUTTON";
            }
            domtoimage
                .toPng(node, {filter: filter})
                .then(function (dataUrl) {
                    // var img = new Image();

                    var imgWidth = 210; // 이미지 가로 길이(mm) A4 기준
                    var pageHeight = imgWidth * 1.414; // 출력 페이지 세로 길이 계산 A4 기준
                    var imgHeight = (node.clientHeight * imgWidth) / node.clientWidth;
                    var heightLeft = imgHeight;

                    var doc = new jsPDF("p", "mm");
                    var position = 0;

                    // 첫 페이지 출력
                    doc.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;

                    // 한 페이지 이상일 경우 루프 돌면서 출력
                    while (heightLeft >= 20) {
                        position = heightLeft - imgHeight;
                        doc.addPage();
                        doc.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
                        heightLeft -= pageHeight;
                    }

                    // 파일 저장
                    doc.save("sample.pdf");

                    // const elemnet = document.createElement("a");
                    // elemnet.setAttribute("download", true);
                    // elemnet.setAttribute("href", dataUrl);
                    // elemnet.click();
                })
                .catch(function (error) {
                    console.error("oops, something went wrong!", error);
                });
        });
    }, []);

    const [elementArr, setElementArr] = useState([]);
    const [elementArr2, setElementArr2] = useState([]);
    const ReportElement = (props) => {
        return (
            <li>
                <button onClick={(event) => onElementRemove(event)} className="remove_items">
                    삭제
                </button>
                <div className="report_item_left">
                    <span className="contentEditable_wrapper" suppressContentEditableWarning={true} contentEditable={true} spellCheck={false}>
                        항목명
                    </span>
                </div>
                <div className="report_item_right">
                    <span className="contentEditable_wrapper" suppressContentEditableWarning={true} contentEditable={true} spellCheck={false}>
                        - 상세설명
                    </span>
                </div>
            </li>
        );
    };

    const onElementClick = (event) => {
        setElementArr(elementArr.concat(<ReportElement elementKey={elementArr.length} key={elementArr.length} />));
    };
    const onElementClickV2 = (event) => {
        setElementArr2(elementArr2.concat(<ReportElement elementKey={elementArr2.length} key={elementArr2.length} />));
    };
    const onElementRemove = (event) => {
        event.target.parentNode.style.display = "none";
    };

    return (
        <>
            <div className="main_wrapper">
                <LeftGnb />
                <div className="app_wrapper">
                    <AppHeader headerArr={["APP", "주간보고서 작성"]} />
                    <div className="report_wrapper">
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "15px",
                                justifyContent: "center",
                            }}
                            contentEditable={true}
                            suppressContentEditableWarning={true}
                            spellCheck={false}
                            className="report_title"
                        >
                            <div>
                                <h1
                                    style={{
                                        fontSize: "50px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    2022
                                </h1>
                                <span
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        fontSize: "18px",
                                    }}
                                >
                                    02.28 ~ 03.11
                                </span>
                            </div>
                            <p
                                style={{
                                    fontSize: "26px",
                                    fontWeight: "bold",
                                }}
                            >
                                개발
                            </p>
                        </div>
                        <div className="report_content_wrapper">
                            <div className="report_content_wrapper_left">
                                <h1 contentEditable={true} suppressContentEditableWarning={true} spellCheck={false}>
                                    전주 실적 02.28 ~ 03.04
                                </h1>
                                <ul>{elementArr}</ul>
                                <button className="add_button" onClick={onElementClick}>
                                    추가하기
                                </button>
                            </div>
                            <div className="report_content_wrapper_right">
                                <h1 contentEditable={true} suppressContentEditableWarning={true} spellCheck={false}>
                                    금주 계획 03.07 ~ 03.11
                                </h1>
                                <ul>{elementArr2}</ul>
                                <button onClick={onElementClickV2} className="add_button">
                                    추가하기
                                </button>
                            </div>
                        </div>
                        <button className="export_to_pdf">PDF로 내보내기</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Report;
